module.exports = __webpack_public_path__ + "img/best-sale.81f0745a.svg";